import { render, staticRenderFns } from "./Discountcom.vue?vue&type=template&id=f66dbf0a"
import script from "./Discountcom.vue?vue&type=script&lang=js"
export * from "./Discountcom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports